export enum DisplayOfferModeEnum {
  VALID = 'VALID',
  VALID_AND_WITHOUT_CONSTRAINTS = 'VALID_AND_WITHOUT_CONSTRAINTS',
  QUOTATION_AND_WITHOUT_CONSTRAINTS = 'QUOTATION_AND_WITHOUT_CONSTRAINTS',
}
